// mobile-header.js
(function () {
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // ---------- Drawer (burger)
  const drawer   = $('[data-menu-drawer]');
  const backdropMenu = $('[data-menu-backdrop]');
  const closeBtn = $('[data-menu-close]');
  const openBtns = $$('[data-menu-toggle]');
  const openDrawer  = () => { hidePS(); drawer && drawer.classList.remove('hidden'); };
  const closeDrawer = () => drawer && drawer.classList.add('hidden');

  openBtns.forEach(b => b.addEventListener('click', openDrawer));
  backdropMenu && backdropMenu.addEventListener('click', closeDrawer);
  closeBtn && closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { hidePS(); closeDrawer(); } });

  // Accordion in drawer
  $$('[data-acc-toggle]').forEach(btn => {
    const panel = btn.closest('li')?.querySelector('[data-acc-panel]');
    if (!panel) return;
    btn.addEventListener('click', () => {
      const willOpen = panel.classList.contains('hidden');
      btn.setAttribute('aria-expanded', String(willOpen));
      panel.classList.toggle('hidden');
    });
  });

  // ---------- Cart hook
  $$('[data-cart-toggle]').forEach((b) => {
    b.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('toggle-cart'));      // общий кастомный эвент
      document.body.classList.toggle('cart-open');                 // некоторые темы слушают класс
      if (typeof window.openCartDrawer === 'function') window.openCartDrawer(); // если у темы есть функция
    });
  });

  // ---------- Predictive Search
  const root     = $('[data-ps-root]');
  if (!root) return;

  const form     = $('[data-ps-form]', root);
  const input    = $('[data-ps-input]', root);
  const panel    = $('[data-ps-panel]', root);
  const backdrop = $('[data-ps-backdrop]');
  const sugList  = $('[data-ps-suggestions]', root);
  const prodList = $('[data-ps-products]', root);
  const sugTitle = $('[data-ps-suggestions-title]', root);
  const prodTitle= $('[data-ps-products-title]', root);
  const viewAll  = $('[data-ps-viewall]', root);

  const showPS = () => { panel.classList.remove('hidden'); backdrop.classList.remove('hidden'); };
  const hidePS = () => { panel.classList.add('hidden'); backdrop.classList.add('hidden'); };

  const debounce = (fn, d=180) => { let t; return (...a)=>{ clearTimeout(t); t=setTimeout(()=>fn(...a), d); }; };

  const currencyISO = (window.Shopify && Shopify.currency && Shopify.currency.active) || (window.shopCurrency) || 'USD';
  const formatPrice = (cents) => {
    const val = (cents || 0) / 100;
    try { return new Intl.NumberFormat(undefined,{style:'currency',currency:currencyISO}).format(val); }
    catch(e){ return val.toFixed(2); }
  };

  const render = (data, q) => {
    // Suggestions
    const qList = (data?.queries || []).slice(0, 5);
    sugList.innerHTML = '';
    if (qList.length) {
      sugTitle.style.display = '';
      qList.forEach(item => {
        const li = document.createElement('li');
        li.innerHTML = `<a class="block py-1.5 hover:underline" href="/search?q=${encodeURIComponent(item.text)}">${item.text}</a>`;
        sugList.appendChild(li);
      });
    } else { sugTitle.style.display = 'none'; }

    // Products
    const prods = (data?.resources?.results?.products || []).slice(0, 6);
    prodList.innerHTML = '';
    if (prods.length) {
      prodTitle.style.display = '';
      prods.forEach(p => {
        const price = p.price || p.price_min || p.final_price || 0;
        const img = p.image || (p.images && p.images[0] && p.images[0].url);
        const li = document.createElement('li');
        li.innerHTML = `
          <a class="flex gap-3 items-center" href="${p.url}">
            <img src="${img ? img : ''}" alt="" class="w-16 h-16 object-cover rounded-md bg-black/5">
            <div class="min-w-0">
              <div class="text-sm font-medium truncate">${p.title}</div>
              <div class="text-sm text-black/70">${formatPrice(price)}</div>
            </div>
          </a>`;
        prodList.appendChild(li);
      });
    } else { prodTitle.style.display = 'none'; }

    viewAll.onclick = () => { window.location.href = `/search?q=${encodeURIComponent(q)}`; };
  };

  const fetchSuggest = debounce(async (q) => {
    if (!q || q.trim().length < 2) { hidePS(); return; }
    const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,query&resources[limit]=6&section_id=predictive-search`;
    try {
      const r = await fetch(url, { headers: { 'Accept': 'application/json' } });
      const data = await r.json();
      render(data, q);
      showPS();
    } catch (e) {
      console.error('Predictive search error', e);
      hidePS();
    }
  }, 200);

  // events
  const clearBtn = root.querySelector('[data-search-clear]');

  input?.addEventListener('input', () => {
    const val = input.value;
    if (clearBtn) clearBtn.classList.toggle('hidden', !val.length);
    fetchSuggest(val);
  });

  clearBtn?.addEventListener('click', () => {
    input.value = '';
    input.focus();
    hidePS();
  });

  form?.addEventListener('submit', (e) => {
    e.preventDefault();
    fetchSuggest(input.value);
  });

  backdrop?.addEventListener('click', hidePS);
})();
